<script lang="ts">
import { PropType } from 'vue';

import type { Address } from '@/utils/orderDetails';

export default {
  name: 'AddressBuilder',
  props: {
    address: { required: true, type: Object as PropType<Address> },
  },
};
</script>

<template>
  <div>
    <p v-if="address.name" class="escape-legacy">{{ address.name }}</p>
    <p v-if="address.phone1" class="escape-legacy">{{ address.phone1 }}</p>
    <p v-if="address.company" class="escape-legacy">{{ address.company }}</p>
    <p v-if="address.street1" class="escape-legacy" data-test="address-street">
      {{ address.street1 }}
    </p>
    <p v-if="address.street2" class="escape-legacy">{{ address.street2 }}</p>
    <p v-if="address.city" class="escape-legacy">
      {{ address.city }},
      <span v-if="address.state_prov"> {{ address.state_prov }} {{ address.postal_code }}</span>
    </p>
    <p v-if="address.country_name">{{ address.country_name }}</p>
  </div>
</template>
